import { render } from "./ButtonDiv.vue?vue&type=template&id=0d6593c6&scoped=true"
const script = {}

import "./ButtonDiv.vue?vue&type=style&index=0&id=0d6593c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d6593c6"]])

export default __exports__